import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
import Default from "@/pages/Main/Default.vue";
import MainPage from "@/pages/Main/MainPage.vue";

// Login
import Login from "@/pages/Login/Login.vue";
import FindId from "@/pages/Login/FindId.vue";
import FindPw from "@/pages/Login/FindPw.vue";
import Signup from "@/pages/Login/Signup.vue";

// Member
import MemberManage from "@/pages/Member/MemberManage.vue";

// Board
import BoardMain from "@/pages/Board/BoardMain.vue";
import CategoryManage from "@/pages/Board/CategoryManage.vue";
import BoardTable from "@/pages/Board/components/Board/BoardTable.vue";
import BoardDetail from "@/pages/Board/BoardDetail.vue";
import BoardWrite from "@/pages/Board/components/Board/BoardWrite.vue";
import BoardModify from "@/pages/Board/components/Board/BoardModify.vue";

// Loan
import LoanPerformanceUpload from "@/pages/Loan/LoanPerformanceUpload.vue";
import LoanStatics from "@/pages/Loan/LoanStatics.vue";
import LoanPerformanceTotal from "@/pages/Loan/LoanPerformanceTotal.vue";
import LoanPerformanceTeam from "@/pages/Loan/LoanPerformanceTeam.vue";
import LoanPerformanceMine from "@/pages/Loan/LoanPerformanceMine.vue";
import CommissionCalculation from "@/pages/Loan/CommissionCalculation.vue";

// User
import MyPage from "@/pages/User/MyPage.vue";
import ChangePW from "@/pages/User/ChangePW.vue";

// Certificate
import Certificate from "@/pages/Certificate/Certificate.vue";


// Lecture
import LectureList from "@/pages/Lecture/LectureList.vue";
import LectureManage from "@/pages/Lecture/LectureManage.vue";
import LectureCategory from "@/pages/Lecture/LectureCategory.vue";

// Etc
import ServiceLog from "@/pages/Etc/ServiceLog.vue";
import PaymentStatement from "@/pages/Payment/PaymentStatement.vue";
import PaymentManage from "@/pages/Payment/PaymentManage.vue";


Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "Default",
            component: Default,
            meta: { breadcrumb: ">" },
            children: [
                // Main
                {
                    path: "/main",
                    name: "MainPage",
                    component: MainPage
                },
                // Login
                {
                    path: "/login",
                    name: "Login",
                    component: Login
                },
                {
                    path: "/signup",
                    name: "Signup",
                    component: Signup
                },
                {
                    path: "/findId",
                    name: "FindId",
                    component: FindId
                },
                {
                    path: "/findPw",
                    name: "FindPw",
                    component: FindPw
                },
                // Member
                {
                    path: "/member/manage",
                    name: "MemberManage",
                    component: MemberManage
                },
                // User
                {
                    path: "/myPage",
                    name: "MyPage",
                    component: MyPage
                },
                {
                    path: "/changePW",
                    name: "ChangePW",
                    component: ChangePW
                },
                // Board
                {
                    path: "/board",
                    name: "BoardMain",
                    component: BoardMain
                },
                {
                    path: "/board/manage",
                    name: "CategoryManage",
                    component: CategoryManage
                },
                {
                    path: "/board/:categoryId",
                    name: "BoardTable",
                    component: BoardTable
                },
                {
                    path: "/board/:boardId/detail",
                    name: "BoardDetail",
                    component: BoardDetail
                },
                {
                    path: "/board/:categoryId/write",
                    name: "BoardWrite",
                    component: BoardWrite
                },
                {
                    path: "/board/:boardId/modify",
                    name: "BoardModify",
                    component: BoardModify
                },
                // Loan
                {
                    path: "/loan/perform/upload",
                    name: "LoanPerformanceUpload",
                    component: LoanPerformanceUpload
                },
                {
                    path: "/loan/statics",
                    name: "LoanStatics",
                    component: LoanStatics
                },
                {
                    path: "/loan/perform/total",
                    name: "LoanPerformanceTotal",
                    component: LoanPerformanceTotal
                },
                {
                    path: "/loan/perform/team",
                    name: "LoanPerformanceTeam",
                    component: LoanPerformanceTeam
                },
                {
                    path: "/loan/perform/mine",
                    name: "LoanPerformanceMine",
                    component: LoanPerformanceMine
                },
                {
                    path: "/loan/commission",
                    name: "CommissionCalculation",
                    component: CommissionCalculation
                },
                // Certificate
                {
                    path: "/certificate",
                    name: "Certificate",
                    component: Certificate
                },
                // Lecture
                {
                    path: "/lecture",
                    name: "LectureList",
                    component: LectureList
                },
                {
                    path: "/lecture/manage",
                    name: "LectureManage",
                    component: LectureManage
                },
                {
                    path: "/lecture/category",
                    name: "LectureCategory",
                    component: LectureCategory
                },
                // Payment
                {
                    path: "/payment/manage",
                    name: "PaymentManage",
                    component: PaymentManage
                },
                {
                    path: "/payment",
                    name: "PaymentStatement",
                    component: PaymentStatement
                },
                // Etc
                {
                    path: "/etc/log",
                    name: "ServiceLog",
                    component: ServiceLog
                }
            ]
        }
    ]
});



router.beforeEach(function (to, from, next) {
    if (
        to.name === "Login" ||
        to.name === "Signup" ||
        to.name === "FindId" ||
        to.name === "FindPw"
    ) {
        store.dispatch("layout/disabledLayout", true)
            .then(() => {
                next();
            })
    } else if (to.name) {
        store.dispatch("layout/disabledLayout", false)
            .then(() => {
                next();
            })
    } else {
        store.dispatch("layout/disabledLayout", false)
            .then(() => {
                next();
            })
    }
})
export default router